export default __webpack_public_path__ + "images/classified_instruction_1-PIWI5.png";